<template>
  <transition v-bind="transitionProps">
    <div v-show="isSelected() && inLdapDirectoryAside && isParentSambaEnabled()">
      <CustomSelectIconList
        :menuItems="menuItems"
        :selectedValueIconClassName="selectedValueIconClassName"
        :selectedValueText="selectedValueText"
      />
    </div>
  </transition>
</template>
<script>
import {
  ItemTypeConsts,
  StoreModelMap,
  StoreModuleMap,
} from 'client/util/Constants';
import { mapActions, mapGetters, mapState } from 'vuex';
import CustomSelectIconList from 'client/components/ItemTable/BodyComponents/CustomSelectIconList.vue';

const sambaModel = StoreModelMap[ItemTypeConsts.samba];
const userGroupCollection = StoreModuleMap[ItemTypeConsts.userGroup];

export default {
  name: 'SambaAuthentication',

  components: {
    CustomSelectIconList,
  },

  props: {
    inLdapDirectoryAside: {
      type: Boolean,
      default: false,
    },
    item: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      menuItems: [
        {
          onClick: () => this.handleSambaAuthChanged(false),
          iconClassName: ['jc-actions-x', 'neutral'],
          text: 'Samba Authentication Disabled',
        },
        {
          onClick: () => this.handleSambaAuthChanged(true),
          iconClassName: ['jc-actions-check', 'secondary-brand-a'],
          text: 'Samba Authentication Enabled',
        },
      ],
    };
  },

  computed: {
    ...mapState(sambaModel, {
      authenticationEnabled: state => state.item.authenticationEnabled,
    }),

    ...mapGetters(userGroupCollection, {
      selectedItems: 'getSelectedItems',
    }),

    selectedValueIconClassName() {
      const index = this.isItemSambaEnabled() ? 1 : 0;
      return this.menuItems[index].iconClassName;
    },

    selectedValueText() {
      const index = this.isItemSambaEnabled() ? 1 : 0;
      return this.menuItems[index].text;
    },

    transitionProps() {
      return {
        enterClass: this.$style.containerEnter,
        enterActiveClass: this.$style.containerTransition,
        leaveActiveClass: this.$style.containerTransition,
        leaveToClass: this.$style.containerLeaveTo,
      };
    },
  },

  methods: {
    ...mapActions(userGroupCollection, [
      'disableSambaGroup',
      'enableSambaGroup',
    ]),

    ...mapGetters(userGroupCollection, [
      'isSambaEnabled',
    ]),

    handleSambaAuthChanged(enable) {
      if (enable) {
        this.enableSambaGroup(this.item.id);
      } else {
        this.disableSambaGroup(this.item.id);
      }
    },

    isItemSambaEnabled() {
      return this.isSambaEnabled()(this.item.id);
    },

    isParentSambaEnabled() {
      if (this.inLdapDirectoryAside) {
        return this.authenticationEnabled;
      }

      return false;
    },

    isSelected() {
      return this.selectedItems.indexOf(this.item.id) !== -1;
    },
  },
};
</script>
<style scoped module>
@value (panelSpeed, panelTimingFunction) from '~css/transitions.css';

.containerEnter,
.containerLeaveTo {
  opacity: 0;
}

.containerTransition {
  transition: opacity panelSpeed panelTimingFunction;
}
</style>
